import { Phone, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const links = [
  { href: "/speisekarte", label: "Speisekarte", isRoute: true },
  { href: "/#ueber-uns", label: "Über uns" },
  { href: "/#bewertungen", label: "Bewertungen" },
  { href: "/#bewerben", label: "Bewerben" },
  { href: "/#kontakt", label: "Kontakt" },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[var(--niko-dark)] text-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-3 gap-12 items-start">
          <div>
            <Logo tone="light" />
            <p className="mt-5 text-sm text-white/60 max-w-xs leading-relaxed font-greek italic text-lg">
              Ihr Grieche in Bochum-Höntrop — seit 44 Jahren mit Herz und
              Gastfreundschaft.
            </p>
          </div>

          <div>
            <p className="text-[11px] tracking-[0.24em] uppercase text-[var(--niko-gold)] mb-5">
              Navigation
            </p>
            <ul className="space-y-3 text-sm">
              {links.map((l) => (
                <li key={l.href}>
                  {l.isRoute ? (
                    <Link
                      to={l.href}
                      className="text-white/75 hover:text-[var(--niko-gold)] transition-colors"
                    >
                      {l.label}
                    </Link>
                  ) : (
                    <a
                      href={l.href}
                      className="text-white/75 hover:text-[var(--niko-gold)] transition-colors"
                    >
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[11px] tracking-[0.24em] uppercase text-[var(--niko-gold)] mb-5">
              Kontakt
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="tel:+492327995454"
                  className="flex items-center gap-3 text-white/75 hover:text-[var(--niko-gold)] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-4 h-4" />
                  +49 2327 995454
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/nikosgrillhoentrop"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/75 hover:text-[var(--niko-gold)] transition-colors"
                  data-testid="footer-instagram"
                >
                  <Instagram className="w-4 h-4" />
                  @nikosgrillhoentrop
                </a>
              </li>
              <li className="text-white/55 text-xs mt-3 leading-relaxed">
                Höntroper Str. 2 <br />
                44869 Bochum
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/55">
            © 2026 Niko's Grill · Höntroper Str. 2, 44869 Bochum
          </p>
          <div className="flex items-center gap-6 text-xs">
            <Link
              to="/impressum"
              data-testid="footer-impressum"
              className="text-white/65 hover:text-[var(--niko-gold)] transition-colors"
            >
              Impressum
            </Link>
            <Link
              to="/datenschutz"
              data-testid="footer-datenschutz"
              className="text-white/65 hover:text-[var(--niko-gold)] transition-colors"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
